import cx from 'classnames';
import { Image } from 'platform-components';
import React from 'react';

import './content-showcase__icon.scss';

interface Props {
    backgroundColor?: string;
    src?: string;
    mix?: string;
}

export const ContentShowcaseIcon = (props: Props) => {
    const { backgroundColor, mix, src } = props;

    if (!src) {
        return null;
    }

    const style: React.CSSProperties = {};
    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }

    return (
        <div className={cx('content-showcase-widget__icon', mix)} style={style}>
            <Image alt="" src={src} />
        </div>
    );
};
